// Brand palette from theme.md - single source of truth
// Using descriptive, semantic names for clarity
const brandPalette = {
  // Core brand colors
  'brand-color': "#2E5090",        // Primary Brand Colour - navigation, buttons, trust moments
  'accent-color': "#E87722",       // Accent / CTA - secondary actions, emphasis

  // Surface colors
  'background-color': "#F6F8FA",   // App background, dashboards
  'surface-color': "#FFFFFF",      // Cards, modals, containers

  // Text colors
  'heading-color': "#2E2E2E",      // Headings, titles
  'text-color': "#2E2E2E",         // Body text
  'text-muted': "#6B7280",         // Helper text, labels, metadata

  // UI colors
  'border-color': "#E5E7EB",       // Borders, dividers, disabled states
  'outlined-color': "#6B7280",     // Button outlined color

  // Semantic states
  'success-color': "#43A047",
  'info-color': "#2196F3",
  'warning-color': "#FFC107",
  'error-color': "#DE0500",
  'danger-color': "#DE0500",

  // Calculated variants (for hover/active states)
  'brand-color-light': "#3B66B5",    // Brand +20% lighter
  'brand-color-lighten': "#E6EBF5",  // Brand +60% lighter
  'brand-color-dark': "#243F73",     // Brand -20% darker
  'brand-color-darker': "#15243E",   // Brand -40% darker

  'accent-color-light': "#ea8438",    // Accent +20% lighter
  'accent-color-lighten': "#ec924e",  // Accent +60% lighter
  'accent-color-dark': "#d06b1e",     // Accent -20% darker
  'accent-color-darker': "#b95f1b",  // Accent -40% darker
}

export const CustomTheme = {
  dark: false,
  colors: {
    // Vuetify semantic tokens (keep for compatibility)
    primary: brandPalette['brand-color'],
    secondary: brandPalette['accent-color'],
    background: brandPalette['background-color'],
    surface: brandPalette['surface-color'],
    success: brandPalette['success-color'],
    info: brandPalette['info-color'],
    warning: brandPalette['warning-color'],
    error: brandPalette['error-color'],
    danger: brandPalette['danger-color'],

    // Custom descriptive tokens for direct usage
    'brand-color': brandPalette['brand-color'],
    'accent-color': brandPalette['accent-color'],
    'heading-color': brandPalette['heading-color'],
    'text-color': brandPalette['text-color'],
    'text-muted': brandPalette['text-muted'],
    'border-color': brandPalette['border-color'],
    'background-color': brandPalette['background-color'],
    'surface-color': brandPalette['surface-color'],
    'outlined-color': brandPalette['outlined-color'],
    'brand-color-light': brandPalette['brand-color-light'],
    'brand-color-dark': brandPalette['brand-color-dark'],
    'brand-color-darker': brandPalette['brand-color-darker'],
    'brand-color-lighten': brandPalette['brand-color-lighten'],
    'success-color': brandPalette['success-color'],
    'info-color': brandPalette['info-color'],
    'warning-color': brandPalette['warning-color'],
    'error-color': brandPalette['error-color'],
    'danger-color': brandPalette['danger-color'],
  }
}

// Export CSS custom properties for SCSS
// Injects all brand palette colors as CSS custom properties
export function injectCSSVariables() {
  const root = document.documentElement
  Object.entries(brandPalette).forEach(([key, value]) => {
    // key is already kebab-case: 'brand-color', 'accent-color', etc.
    root.style.setProperty(`--${key}`, value)
  })
}
